import { jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation-10";
import CarouselTab from "./CarouselTab.esm.js";
import { v8ResponsiveToPanda } from "../../utils/token-migration/migrate-responsive.esm.js";
const toPanda = (value) => {
  if (typeof value === "string") {
    return value;
  }
  if (value && typeof value === "object") {
    return v8ResponsiveToPanda(value);
  }
  return void 0;
};
function CarouselItem({
  privateRenderType,
  alignItems,
  justifyContent,
  tab,
  showArrows,
  isActive,
  onClick,
  ...props
}) {
  switch (privateRenderType) {
    case "slide": {
      const slideCss = {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        overflow: "hidden",
        // Runtime values: every option the editor offers is in the
        // staticCss safelist (alignItems / justifyContent).
        alignItems: toPanda(alignItems),
        justifyContent: toPanda(justifyContent)
      };
      return /* @__PURE__ */ jsx(Box, { css: {
        display: "flex",
        flexShrink: "0",
        width: "100%",
        // Literal (not ARROW_COLUMN_WIDTH) so Panda can extract it.
        paddingInline: showArrows ? "35px" : "0"
      }, children: /* @__PURE__ */ jsx(Box, { ...props, css: slideCss }) });
    }
    case "tab":
      return /* @__PURE__ */ jsx(CarouselTab, { isActive, onClick: () => onClick == null ? void 0 : onClick(), children: tab || "Tab" });
    default:
      return null;
  }
}
CarouselItem.displayName = "Carousel.Item";
export {
  CarouselItem as default
};
